module.exports = __webpack_public_path__ + "img/editLogo.9fe2939a.svg";